var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 5C13.6068 5 11.6667 6.9401 11.6667 9.33333C11.6667 11.7266 13.6068 13.6667 16.0001 13.6667C18.3933 13.6667 20.3334 11.7266 20.3334 9.33333C20.3334 6.9401 18.3933 5 16.0001 5ZM9.66675 9.33333C9.66675 5.83553 12.5023 3 16.0001 3C19.4979 3 22.3334 5.83553 22.3334 9.33333C22.3334 12.8311 19.4979 15.6667 16.0001 15.6667C12.5023 15.6667 9.66675 12.8311 9.66675 9.33333Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C11.7689 20 8.0085 23.1887 8.0549 26.9878L8.06711 27.9877L6.06726 28.0121L6.05505 27.0122C5.99153 21.8113 10.9661 18 16 18C21.0384 18 26 21.8118 26 27V28H24V27C24 23.1882 20.2268 20 16 20Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryProfile);
export default __webpack_public_path__ + "static/media/category-profile.9fce7693ab2ff2fb5ccd2b839b874c17.svg";
export { ForwardRef as ReactComponent };